import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { CsvExportButtonComponent } from './components/button/button.component';
import { CsvExportAuditLogDialogComponent } from './components/dialog/dialog-auditlog.component';
import { CsvExportCompoundDialogComponent } from './components/dialog/dialog-compound.component';
import { CsvExportDialogComponent } from './components/dialog/dialog.component';
import { CsvExportsOverlayComponent } from './components/overlay/csv-exports.component';
import { ExportNamePipe } from './filters/export-name.pipe';
import { ExporterQaParserService } from './services/history/qa.service';
import { ExporterSeoParserService } from './services/history/seo.service';
import { ExporterPolicyParserService } from './services/history/policy.service';
import { ExporterAccessibilityParserService } from './services/history/accessibility.service';
import { ExporterReadabilityParserService } from './services/history/readability.service';
import { ExporterDataPrivacyParserService } from './services/history/data-privacy.service';
import { ExporterPerformanceParserService } from './services/history/performance.service';
import { ExporterAllParserService } from './services/history/all.service';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '../../../ng2/core/core.module';
import { AngularSharedComponentsModule, UserDatePipe } from '@monsido/angular-shared-components';
import { TranslateService } from '@monsido_services/services/mon-translate/dist/translate.service';
import { FormsModule } from '@angular/forms';
import { MonNumberPipe } from '@monsido/ng2/core/locale/pipes/mon-number.pipe';

@NgModule({
    declarations: [
        CsvExportButtonComponent,
        CsvExportAuditLogDialogComponent,
        CsvExportCompoundDialogComponent,
        CsvExportDialogComponent,
        CsvExportsOverlayComponent,
        ExportNamePipe,
    ],
    imports: [
        CommonModule,
        NgbTooltipModule,
        CoreModule,
        AngularSharedComponentsModule,
        FormsModule,
    ],
    providers: [
        ExporterQaParserService,
        ExporterSeoParserService,
        ExporterPolicyParserService,
        ExporterAccessibilityParserService,
        ExporterReadabilityParserService,
        ExporterDataPrivacyParserService,
        ExporterPerformanceParserService,
        ExporterAllParserService,
        DatePipe,
        DecimalPipe,
        TranslateService,
        ExportNamePipe,
        MonNumberPipe,
        UserDatePipe,
    ],
    exports: [
        CsvExportButtonComponent,
        CsvExportAuditLogDialogComponent,
        CsvExportCompoundDialogComponent,
        CsvExportDialogComponent,
        CsvExportsOverlayComponent,
    ],
})
export class ExportModule { }
